<template>
<div class="shalfSetting">
    <el-form class="sellWayForm" :model="item" ref="shalfSettingForm" label-width="0" :rules="rules">
        <el-form-item label="" prop="feetype">
            <el-radio-group v-model="item.onlinetype" @change="switchStatus" :disabled="isDisabled">
                <el-radio :label="onlinetype.code" v-for="(onlinetype, index) in onlinetypeList" :key="index">
                    {{onlinetype.name}}
                    <el-date-picker v-if="onlinetype.code == 2" v-model="item.onlinetime" type="datetime" placeholder="选择日期" :disabled="item.onlinetype != 2"
                                    format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                </el-radio>
            </el-radio-group>
            <el-collapse class="setting" v-if="domain === 1">
                <el-collapse-item title="高级设置" name="1">
                    <el-checkbox v-model="item.ispublic" :disabled="isDisabled"><span class="label">店铺内公开</span><span class="tip">上架的商品取消公开后，在店铺内不显示，但可以通过链接的方式访问</span></el-checkbox>
                    <el-checkbox v-model="item.isplatform" :disabled="isDisabled"><span class="label">平台发布</span><span class="tip">官网发布，快速提高曝光率和增加浏览量</span></el-checkbox>
                </el-collapse-item>
            </el-collapse>
        </el-form-item>
    </el-form>
</div>
</template>

<script>
import {videoMgtCode} from 'api/enumCode'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'shalfSetting',
    data() {
        let checkOnlineWay = (rule, value, callback) => {
            if (this.item.onlinetype === 2) {
                if (!this.item.onlinetime) {
                    callback(new Error('请选择上架时间'))
                } else {
                    callback()
                }
            } else {
                callback()
            }
        }
        return {
            onlinetypeList: videoMgtCode.onlinetype,
            isDisabled: false,
            rules: {
                feetype: [
                    {validator: checkOnlineWay, trigger: 'blur'}
                ]
            }
        }
    },
    props: ['item'],
    mounted() {
    },
    methods: {
        setDisabled() {
            this.isDisabled = true
        },
        // 切换上线时间
        switchStatus () {
            if (this.item.onlinetype.code !== 2) {
                this.item.onlinetime = ''
            }
        },
        checkShalfSetting() {
            let flag = false
            this.$refs.shalfSettingForm.validate((v) => {
                flag = v
            })
            return flag
        }
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'loading',
            'user',
            'domain'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.shalfSetting {
    .el-collapse-item__wrap,.el-collapse,.el-collapse-item__header{
        border-width: 0;
    }
    .el-collapse-item__arrow{
        margin: 0 5px;
    }
    .el-collapse-item__header{
        color: $tcolor-blue;
    }
    .el-radio{
        display: block;
        margin-top: 10px;
    }
    .setting{
        .el-checkbox{
            margin-left: 20px;
            display: block;
        }
        .el-checkbox ~.el-checkbox{
            margin-top: 15px;
        }
        .tip{
            margin-left: 20px;
            color: $tcolor-lightgrey;
        }
        .label{
            display: inline-block;
            width: 80px;
        }
    }
}
</style>
